document.addEventListener('DOMContentLoaded', () => {
  const modals = document.querySelectorAll('[data-discount-modal]');
  const urlParams = new URLSearchParams(window.location.search);
  const isDesignMode = document.documentElement.classList.contains('shopify-design-mode');

  modals.forEach((modal) => {
    const sectionId = modal.dataset.sectionId || 'global-discount-modal';
    const displayMode = modal.dataset.displayMode || 'query_param';
    const triggerParam = modal.dataset.triggerParam || 'afsrc';
    const delaySeconds = Number(modal.dataset.delaySeconds || 0);
    const showOnce = modal.dataset.showOnce !== 'false';
    const previewInEditor = modal.dataset.previewInEditor !== 'false';

    const copyButton = modal.querySelector('[data-copy-button]');
    const copyButtonLabel = modal.querySelector('[data-copy-button-label]');
    const codeElement = modal.querySelector('[data-discount-code]');
    const closeButtons = modal.querySelectorAll('[data-discount-modal-close]');

    const activeClass = 'is-active';
    const triggerStorageKey = `discount_modal_trigger_${sectionId}`;
    const shownStorageKey = `discount_modal_shown_${sectionId}`;
    let openTimer;

    const markShown = () => {
      if (showOnce) {
        sessionStorage.setItem(shownStorageKey, '1');
      }
    };

    const canOpen = () => !showOnce || !sessionStorage.getItem(shownStorageKey);

    const openModal = () => {
      if (!canOpen()) return;
      modal.classList.add(activeClass);
      document.body.classList.add('discount-popup-open');
      markShown();
    };

    const closeModal = () => {
      modal.classList.remove(activeClass);
      document.body.classList.remove('discount-popup-open');
    };

    closeButtons.forEach((button) => {
      button.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && modal.classList.contains(activeClass)) {
        closeModal();
      }
    });

    if (copyButton && copyButtonLabel && codeElement) {
      const defaultLabel = copyButton.dataset.copyDefaultLabel || copyButtonLabel.textContent.trim();
      const successLabel = copyButton.dataset.copySuccessLabel || 'Copied';

      copyButton.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(codeElement.textContent.trim());
          copyButton.classList.add('is-copied');
          copyButtonLabel.textContent = successLabel;

          window.clearTimeout(copyButton._resetTimer);
          copyButton._resetTimer = window.setTimeout(() => {
            copyButton.classList.remove('is-copied');
            copyButtonLabel.textContent = defaultLabel;
          }, 2000);
        } catch (error) {
          copyButtonLabel.textContent = defaultLabel;
        }
      });
    }

    window.addEventListener('pagehide', () => {
      if (openTimer) {
        window.clearTimeout(openTimer);
      }
    });

    if (isDesignMode && previewInEditor) {
      modal.classList.add(activeClass);
      document.body.classList.add('discount-popup-open');
      return;
    }

    if (displayMode === 'query_param' && urlParams.get(triggerParam) === '1') {
      sessionStorage.setItem(triggerStorageKey, '1');
      sessionStorage.removeItem(shownStorageKey);
    }

    if (displayMode === 'automatic') {
      if (canOpen()) {
        openTimer = window.setTimeout(openModal, delaySeconds * 1000);
      }
      return;
    }

    if (sessionStorage.getItem(triggerStorageKey) === '1' && canOpen()) {
      openTimer = window.setTimeout(openModal, delaySeconds * 1000);
    }
  });
});